<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Pengaduan',

    metaInfo: { title: 'Pengaduan' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'complain',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'complain',
      },
    },
  }
</script>
